export const MEEM_EVIDENCE = Object.freeze([
  {
    id: 'folstein-1975',
    citation: 'Folstein MF, Folstein SE, McHugh PR. "Mini-mental state": a practical method for grading the cognitive state of patients for the clinician. J Psychiatr Res. 1975;12(3):189-198.',
    year: 1975,
    population: 'Publicação original do Mini-Mental State Examination; a página primária indexada confirma a publicação, autores e DOI, mas não expõe no resumo os detalhes completos da amostra.',
    sampleSize: null,
    dataType: 'instrument-origin',
    results: { cutoff: null },
    limitations: [
      'É a publicação de origem do instrumento, não uma referência brasileira de escolaridade.',
      'Os detalhes completos da amostra não estão disponíveis no resumo primário consultado; por isso não são inferidos aqui.'
    ],
    primarySource: { kind: 'doi', value: '10.1016/0022-3956(75)90026-6' },
    usedBy: ['/pontos-de-corte', '/evidencia-brasileira']
  },
  {
    id: 'bertolucci-1994',
    citation: 'Bertolucci PHF, Brucki SMD, Campacci SR, Juliano Y. O Mini-Exame do Estado Mental em uma população geral: impacto da escolaridade. Arq Neuropsiquiatr. 1994;52(1):1-7.',
    year: 1994,
    population: '530 adultos brasileiros avaliados quanto ao efeito de idade e escolaridade; os valores de referência foram comparados a 94 pacientes com comprometimento cognitivo.',
    sampleSize: 530,
    comparisonSampleSize: 94,
    dataType: 'education-specific-cutoff',
    results: {
      method: 'percentil 5 da porção inferior da distribuição em cada grupo de escolaridade, seguido de comparação com pacientes com comprometimento cognitivo',
      groups: {
        noFormalEducation: { cutoff: 13, sensitivity: 82.4, specificity: 97.5 },
        lowAndMiddleEducation: { cutoff: 18, sensitivity: 75.6, specificity: 96.6 },
        highEducation: { cutoff: 26, sensitivity: 80, specificity: 95.6 }
      }
    },
    limitations: [
      'As categorias educacionais são amplas e refletem a classificação usada em 1994.',
      'Os valores derivam da amostra e do método de definição de corte daquele estudo; não constituem um limiar universal para toda população ou doença.'
    ],
    primarySource: { kind: 'doi', value: '10.1590/S0004-282X1994000100001' },
    usedBy: ['/pontos-de-corte']
  },
  {
    id: 'brucki-2003',
    citation: 'Brucki SMD, Nitrini R, Caramelli P, Bertolucci PHF, Okamoto IH. Sugestões para o uso do Mini-Exame do Estado Mental no Brasil. Arq Neuropsiquiatr. 2003;61(3B):777-781.',
    year: 2003,
    population: '433 indivíduos saudáveis sem queixas de perda de memória: 289 avaliados no Hospital Santa Marcelina, em sua maioria acompanhantes de pacientes, e 144 de amostra epidemiológica em Catanduva. Idades de 16 a 92 anos.',
    sampleSize: 433,
    subitemSampleSize: 185,
    dataType: 'descriptive-reference',
    results: {
      educationMedians: {
        noFormalEducation: 20,
        years1To4: 25,
        years5To8: 26.5,
        years9To11: 28,
        years12OrMore: 29
      },
      cutoff: null
    },
    limitations: [
      'As medianas descrevem o desempenho dos grupos da amostra; o estudo não definiu esses números como pontos de corte diagnósticos.',
      'A própria publicação destaca heterogeneidade do ensino brasileiro, sobretudo nos grupos de menor escolaridade.',
      'A análise dos subitens foi feita em apenas 185 dos 433 participantes; esse n não deve ser confundido com a amostra total.'
    ],
    primarySource: { kind: 'doi', value: '10.1590/S0004-282X2003000500014' },
    usedBy: ['/pontos-de-corte', '/escolaridade', '/']
  },
  {
    id: 'lourenco-veras-2006',
    citation: 'Lourenço RA, Veras RP. Mini-Exame do Estado Mental: características psicométricas em idosos ambulatoriais. Rev Saúde Pública. 2006;40(4):712-719.',
    year: 2006,
    population: '303 indivíduos com mais de 65 anos atendidos em ambulatório geral/atenção primária, submetidos a avaliação geriátrica abrangente.',
    sampleSize: 303,
    dataType: 'diagnostic-accuracy',
    results: {
      overall: { cutoffPair: '23/24', sensitivity: 80.8, specificity: 65.3, positivePredictiveValue: 44.7, negativePredictiveValue: 90.7, auc: 0.807 },
      groups: {
        noFormalEducation: { cutoffPair: '18/19', sensitivity: 73.5, specificity: 73.9 },
        formalEducation: { cutoffPair: '24/25', sensitivity: 75, specificity: 69.7 }
      }
    },
    limitations: [
      'A amostra é de idosos ambulatoriais com mais de 65 anos; os resultados não devem ser extrapolados automaticamente para adultos mais jovens ou outros contextos.',
      'Sensibilidade e especificidade pertencem a esta população e ao padrão de referência usado no estudo.'
    ],
    primarySource: { kind: 'doi', value: '10.1590/S0034-89102006000500023' },
    usedBy: ['/pontos-de-corte', '/escolaridade']
  },
  {
    id: 'hensel-2007',
    citation: 'Hensel A, Angermeyer MC, Riedel-Heller SG. Measuring cognitive change in older adults: reliable change indices for the Mini-Mental State Examination. J Neurol Neurosurg Psychiatry. 2007.',
    year: 2007,
    population: '119 participantes cognitivamente normais com 75 anos ou mais.',
    sampleSize: 119,
    dataType: 'longitudinal-reliable-change',
    retestInterval: '1,5 ano',
    followUp: '6 avaliações; seguimento médio de 7,1 anos',
    results: { reliableChangeRange: [2, 4], confidenceInterval: 90 },
    limitations: [
      'A faixa de 2–4 pontos depende da comparação e do método de índice de mudança confiável.',
      'A amostra foi de idosos cognitivamente normais com 75 anos ou mais; não é regra universal.'
    ],
    primarySource: { kind: 'pmid', value: '17442763' },
    usedBy: ['/acompanhamento-e-queda-de-pontos']
  },
  {
    id: 'feeney-2016',
    citation: 'Feeney J, et al. Measurement error, reliability, and minimum detectable change in the Mini-Mental State Examination. 2016.',
    year: 2016,
    population: '130 adultos residentes na comunidade com 55 anos ou mais, sem comprometimento cognitivo grave.',
    sampleSize: 130,
    dataType: 'measurement-error',
    retestInterval: '2–4 meses',
    results: { standardErrorOfMeasurement: 1, minimumDetectableChange95: 3 },
    limitations: [
      'O MDC95 de 3 pontos pertence à população, intervalo e método deste estudo.',
      'Mudança mínima detectável não equivale automaticamente a mudança clinicamente importante.'
    ],
    primarySource: { kind: 'pmid', value: '27258421' },
    usedBy: ['/acompanhamento-e-queda-de-pontos']
  },
  {
    id: 'galasko-1993',
    citation: 'Galasko D, Abramson I, Corey-Bloom J, Thal LJ. Repeated exposure to the Mini-Mental State Examination and the Information-Memory-Concentration Test: effect of practice on Alzheimer patients. Neurology. 1993.',
    year: 1993,
    population: '39 pacientes com doença de Alzheimer.',
    sampleSize: 39,
    dataType: 'practice-effect',
    followUp: '4 avaliações ao longo de 6 semanas',
    results: { practiceEffectMean: 1.12, practiceEffectSE: 0.47 },
    limitations: [
      'O efeito de prática foi estimado em pacientes com Alzheimer e não deve ser extrapolado como magnitude universal.',
      'O estudo sustenta a existência de efeito de reaplicação, não um limiar diagnóstico.'
    ],
    primarySource: { kind: 'pmid', value: '8351011' },
    usedBy: ['/acompanhamento-e-queda-de-pontos']
  },
  {
    id: 'jefferis-2012',
    citation: 'Jefferis JM, Collerton J, Taylor JP, Jagger C, Kingston A, Davies K, Kirkwood T, Clarke MP. The impact of visual impairment on Mini-Mental State Examination Scores in the Newcastle 85+ study. Age Ageing. 2012;41(4):565-568.',
    year: 2012,
    population: '839 participantes de 85 anos do Newcastle 85+ Study; 44 tinham deficiência visual registrada.',
    sampleSize: 839,
    visualImpairmentSampleSize: 44,
    dataType: 'sensory-access-validity',
    results: {
      visualImpairmentMedian: 25,
      noVisualImpairmentMedian: 28,
      visualItemsDifference: true,
      noSignificantDifferenceAfterExcludingVisualItems: true
    },
    limitations: [
      'O estudo é observacional em pessoas de 85 anos; as diferenças não constituem fator de correção do escore.',
      'Deficiência visual pode coexistir com comprometimento cognitivo; nem toda diferença observada deve ser atribuída exclusivamente à visão.'
    ],
    primarySource: { kind: 'doi', value: '10.1093/ageing/afs042' },
    usedBy: ['/adaptacoes-sensoriais']
  },
  {
    id: 'lim-loo-2018',
    citation: 'Lim MYL, Loo JHY. Screening an elderly hearing impaired population for mild cognitive impairment using Mini-Mental State Examination (MMSE) and Montreal Cognitive Assessment (MoCA). Int J Geriatr Psychiatry. 2018;33(7):972-979.',
    year: 2018,
    population: '114 adultos idosos com diferentes graus de perda auditiva, residentes em Singapura, avaliados com audiometria tonal, MMSE e MoCA.',
    sampleSize: 114,
    ageRange: [55, 86],
    dataType: 'sensory-access-validity',
    results: {
      hearingLossAssociatedWithLowerScores: true,
      hearingSensitiveComponentsAffected: ['registration', 'recall']
    },
    limitations: [
      'Associação entre perda auditiva e menor escore não permite separar completamente efeito sensorial de possível comprometimento cognitivo real.',
      'Os resultados pertencem à população e ao desenho deste estudo e não definem compensação matemática do MMSE.'
    ],
    primarySource: { kind: 'doi', value: '10.1002/gps.4880' },
    usedBy: ['/adaptacoes-sensoriais']
  },
  {
    id: 'ophthalmic-mmse-blind-2010',
    citation: 'Cognitive profile of elders in an ophthalmic ambulatory setting. Br J Ophthalmol. 2010.',
    year: 2010,
    population: '84 adultos com 65 anos ou mais em atendimento oftalmológico ambulatorial não emergencial.',
    sampleSize: 84,
    dataType: 'modified-instrument',
    results: {
      mmseStandardMax: 30,
      mmseBlindMax: 22,
      mmseBlindThresholdStudied: 16
    },
    limitations: [
      'A forma MMSE-blind é uma versão modificada com denominador próprio e não deve ser convertida proporcionalmente para 30 pontos.',
      'O limiar estudado nesta amostra oftalmológica não é um ponto de corte brasileiro universal.'
    ],
    primarySource: { kind: 'doi', value: '10.1136/bjo.2010.183459' },
    usedBy: ['/adaptacoes-sensoriais']
  },
  {
    id: 'molloy-1991-standardized-mmse',
    citation: 'Molloy DW, Alemayehu E, Roberts R. Reliability of a Standardized Mini-Mental State Examination compared with the traditional Mini-Mental State Examination. Am J Psychiatry. 1991;148(1):102-105.',
    year: 1991,
    population: '48 idosos estáveis residentes em instituição de longa permanência ou unidade de cuidados crônicos; subgrupos foram avaliados repetidamente por múltiplos aplicadores.',
    sampleSize: 48,
    dataType: 'administration-standardization',
    results: {
      intraraterVarianceReductionPct: 86,
      interraterVarianceReductionPct: 76,
      iccBefore: 0.69,
      iccAfter: 0.90
    },
    limitations: [
      'Os ganhos de confiabilidade pertencem à versão padronizada e ao desenho deste estudo; não quantificam o efeito de cada desvio isolado na pontuação.',
      'A amostra institucionalizada é pequena e não representa toda população em que o MMSE é usado.'
    ],
    primarySource: { kind: 'doi', value: '10.1176/ajp.148.1.102' },
    usedBy: ['/erros-de-aplicacao']
  },
  {
    id: 'attention-variant-2011',
    citation: 'Hawkins KA, Cromer JR, Piotrowski AS, Pearlson GD. Mini-Mental State Exam performance of older African Americans: effect of age, gender, education, hypertension, diabetes, and the inclusion of serial 7s subtraction versus “world” backward on score. Arch Clin Neuropsychol. 2011;26(7):645-652.',
    year: 2011,
    population: '298 adultos afro-americanos de 55 a 87 anos, vivendo de forma independente na comunidade.',
    sampleSize: 298,
    dataType: 'administration-variant',
    results: {
      systematicScoreDifference: true,
      higherTotalWithWorldBackward: true
    },
    limitations: [
      'O estudo avaliou uma população específica e uma variação concreta da seção de atenção/cálculo; não oferece conversão universal entre versões.',
      'A direção da diferença observada não deve ser generalizada para qualquer outra modificação de administração.'
    ],
    primarySource: { kind: 'doi', value: '10.1093/arclin/acr054' },
    usedBy: ['/erros-de-aplicacao']
  },
  {
    id: 'anthony-1989-community-mmse',
    citation: 'O’Connor DW, Pollitt PA, Hyde JB, Fellows JL, Miller ND, Brook CP, Reiss BB. The reliability and validity of the Mini-Mental State in a British community survey. J Psychiatr Res. 1989;23(1):87-96.',
    year: 1989,
    population: '2.302 pacientes de clínica geral com 75 anos ou mais em estudo comunitário britânico.',
    sampleSize: 2302,
    dataType: 'community-diagnostic-validity',
    results: {
      lowScoreThreshold: '≤23',
      lowScoreDementiaOrDeliriumPct: 55
    },
    limitations: [
      'O valor de 55% pertence aos participantes desta amostra que pontuaram 23 ou menos e não é probabilidade universal aplicável a qualquer paciente.',
      'O estudo sustenta a necessidade de investigação adicional e não autoriza diagnóstico a partir do escore isolado.'
    ],
    primarySource: { kind: 'doi', value: '10.1016/0022-3956(89)90021-6' },
    usedBy: ['/erros-de-aplicacao']
  }
]);

export function getEvidenceById(id) {
  return MEEM_EVIDENCE.find((study) => study.id === id);
}
